import React, { useState, useReducer, useEffect } from 'react'
import './App.css'
import AddressForm from './AddressForm'
import Preview from './Preview'
import Pdf from './Pdf'
import { Button, Form, Input, Label, Popup } from 'semantic-ui-react'
import ReactGA from 'react-ga';

// Fix to enable worker when using create-react-app
//window.pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${window.pdfjsLib.version}/pdf.worker.js`

window.SMDenvelope = { gaEnabled: false }

if (window.location.hostname !== 'localhost') {
  window.SMDenvelope.gaEnabled = true
}

if (window.SMDenvelope.gaEnabled) {
  ReactGA.initialize('UA-96846729-5')
  ReactGA.pageview(window.location.pathname + window.location.search)
}

const placeholderAddress = {
  sender: {
    name: 'EXAMPLE SENDER',
    addr1: '100 MAIN STREET',
    city: 'YOUR TOWN',
    state: 'KS',
    postalCode: '66223'
  },
  recipient: {
    name: 'EXAMPLE RECIPIENT',
    addr1: '123 W PARK AVENUE',
    city: 'SOMEPLACE',
    state: 'IN',
    postalCode: '77701'
  }
}

const emptyAddress = {
  name: '',
  addr1: '',
  city: '',
  state: '',
  postalCode: ''
}

const initialFormData = {
  sender: placeholderAddress.sender,
  recipient: placeholderAddress.recipient,
  size: {
    height: 4.25,
    width: 9.5,
  },
}

/*
const inchLimits = {
  minHeight: 3.5,
  maxHeight: 6.25,
  minWidth: 5,
  maxWidth: 11.5,
}
*/

const envelopeTypes = {
  '#10': {
    height: 4.25,
    width: 9.5,
  },
  '#9': {
    height: 3.87,
    width: 8.87,
  },
  '#6 3/4': {
    height: 3.62,
    width: 6.5,
  }
}

const getInitialData = () => {
  const cachedData = JSON.parse(window.localStorage.getItem('formData') || '{}')
  return {
    ...initialFormData,
    sender: { ...initialFormData.sender, ...cachedData.sender },
    recipient: { ...initialFormData.recipient, ...cachedData.recipient },
    size: { ...initialFormData.size, ...cachedData.size },
  }
}

function App() {

  const formReducer = (state, action) => {
    const { subKey, id, value, address } = action.payload
    switch (action.type) {
      case 'updateAddressPart':
        const key = id.replace(`${subKey}_`, '')
        if (subKey === 'sender') {
          return { ...state, sender: { ...state.sender, [key]: value } }
        }
        return { ...state, recipient: { ...state.recipient, [key]: value } }
      case 'updateAddress':
        if (subKey === 'sender') {
          return { ...state, sender: address }
        }
        return { ...state, recipient: address }
      case 'clear':
        if (subKey === 'sender') {
          return { ...state, sender: emptyAddress }
        }
        return { ...state, recipient: emptyAddress }
      case 'updateSize':
        /* This did not work
        let newValue = value
        if (id === 'height') {
          if (newValue < inchLimits.minHeight) { newValue = inchLimits.minHeight}
          if (newValue > inchLimits.maxHeight) { newValue = inchLimits.maxHeight}
        }
        if (id === 'width') {
          if (newValue < inchLimits.minWidth) { newValue = inchLimits.minWidth}
          if (newValue > inchLimits.maxWidth) { newValue = inchLimits.maxWidth}
        } 
        */
        return { ...state, size: { ...state.size, [id]: value } }
      default:
        return state
    }
  }

  const [formData, formDispatch] = useReducer(formReducer, getInitialData())
  const [addressForm, setAddressForm] = useState(null)
  //const [base64DataUri, setBase64DataUri] = useState(null)

  const handleChange = (type, subKey, { target: { id, value } }) => {
    formDispatch({ type, payload: { subKey, id, value } })
  }
  const handleSenderChange = (e) => handleChange('updateAddressPart', 'sender', e)
  const handleRecipientChange = (e) => handleChange('updateAddressPart', 'recipient', e)
  const handleSizeChange = (e) => handleChange('updateSize', 'size', e)

  const clear = subKey => {
    formDispatch({ type: 'clear', payload: { subKey } })
  }
  const clearSender = () => clear('sender')
  const clearRecipient = () => clear('recipient')


  const submitForm = () => {
    cacheData()
  }

  useEffect(submitForm)

  const cacheData = () => {
    window.localStorage.setItem('formData', JSON.stringify(formData))
  }

  const setSize = envelopeType => {
    const envelope = envelopeTypes[envelopeType]
    handleSizeChange({ target: { id: 'height', value: envelope.height } })
    handleSizeChange({ target: { id: 'width', value: envelope.width } })
  }

  /*
  const validate = () => {
    let valid = true
    if (formData.size.height > inchLimits.maxHeight || formData.size.height < inchLimits.minHeight) {
      valid = false
    }
    if (formData.size.width > inchLimits.maxWidth || formData.size.width < inchLimits.minWidth) {
      valid = false
    }
    return valid
  }
  */

  /* https://blog.jayway.com/2017/07/13/open-pdf-downloaded-api-javascript/ */
  const generatePdf = async () => {
    const pdf = await Pdf(formData)
    if (window.SMDenvelope.gaEnabled) {
      ReactGA.event({
        category: 'User',
        action: 'pdf'
      })
    }
    // It is necessary to create a new blob object with mime-type explicitly set
    // otherwise only Chrome works like it should
    const blob = new Blob([pdf.pdfAsArray], { type: "application/pdf" })
    return {
      blob,
      dataUrl: window.URL.createObjectURL(blob)
    }
  }

  /* If you cleanup, then you can't download the PDF from the viewer!
  const cleanup = pdfObj => {
    setTimeout(function(){
      // For Firefox it is necessary to delay revoking the ObjectURL
      window.URL.revokeObjectURL(pdfObj.dataUrl)
    }, 100)
  }
  */

  const doIE = pdfObj => {
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(pdfObj.blob)
      return true
    }
    return false
  }

  const openPdf = async () => {
    const pdfObj = await generatePdf()
    if (doIE(pdfObj)) { return }
    window.open(pdfObj.dataUrl)
  }

  /*
  const downloadPdf = async (dataUrl) => {
    const pdfObj = await generatePdf()
    if (doIE(pdfObj)) { return }
    var link = document.createElement('a')
    link.href = pdfObj.dataUrl
    link.download = 'envelope.pdf'
    link.click()
  }
  */

  const { sender, recipient, size } = formData

  return (
    <div className="App">

      <svg width="200px" height="60px" viewBox="0 0 341.74 99.16" className="logo-center">
        <linearGradient id="gradient-diagonal" x1="0%" y1="0%" x2="100%" y2="100%" spreadMethod="pad">
          <stop offset="0%" stopColor="#9d70fe" stopOpacity="1"></stop>
          <stop offset="100%" stopColor="#6b5cff" stopOpacity="1"></stop>
        </linearGradient>
        <path id="logo" d="M59.33 41.66c-.93-1.18-2.12-2.14-3.57-2.88-1.45-.73-3.23-1.1-5.33-1.1-1.77 0-3.4.32-4.9.95s-2.8 1.5-3.88 2.62c-1.08 1.12-1.93 2.43-2.55 3.95s-.92 3.16-.92 4.92c0 1.77.28 3.4.85 4.93s1.38 2.83 2.42 3.95c1.05 1.12 2.33 2 3.85 2.62s3.2.95 5.08.95c3.83 0 6.93-1.17 9.3-3.5.68-.67.58-1.8-.18-2.4l-.86-.66c-.64-.5-1.54-.4-2.12.16a10.74 10.74 0 0 1-1.9 1.52c-1.03.65-2.25.98-3.65.98-1.03 0-2.03-.17-3-.5s-1.82-.8-2.55-1.4a6.9 6.9 0 0 1-1.77-2.17 6.21 6.21 0 0 1-.31-.7c-.38-1.03.42-2.13 1.52-2.13H60.4c.88 0 1.6-.72 1.6-1.6 0-1.53-.2-3.04-.62-4.53-.43-1.46-1.1-2.8-2.04-3.98zm-3.96 6.53H44.9c-1.12 0-1.9-1.12-1.5-2.16a2.03 2.03 0 0 1 .11-.26c.35-.82.84-1.56 1.47-2.23s1.4-1.2 2.33-1.62c.92-.42 1.92-.62 3.02-.62 1.13 0 2.12.18 2.98.53.85.35 1.56.83 2.12 1.45.57.62 1 1.34 1.27 2.18.1.26.17.54.23.82.24.97-.54 1.9-1.56 1.9zm32.3-5.53c.47 1.15.7 2.5.7 4.08V60.4c0 .88-.72 1.6-1.6 1.6h-1.3c-.88 0-1.6-.72-1.6-1.6V48c0-1.1-.15-2.04-.45-2.83-.3-.78-.7-1.42-1.2-1.9s-1.08-.83-1.73-1.05-1.32-.33-2.02-.33c-.93 0-1.8.15-2.6.45s-1.5.77-2.1 1.42-1.07 1.48-1.4 2.48-.5 2.18-.5 3.55v10.6c0 .88-.72 1.6-1.6 1.6h-1.3c-.88 0-1.6-.72-1.6-1.6v-20.5c0-.88.72-1.6 1.6-1.6h1.3c.88 0 1.6.72 1.6 1.6v2.05h.1c.57-1.27 1.55-2.3 2.95-3.08 1.4-.78 3.02-1.17 4.85-1.17a10.33 10.33 0 0 1 3.28.52c1.05.35 1.97.9 2.75 1.62.78.75 1.4 1.7 1.87 2.84zm27.7-2.2l-8.04 20.5c-.24.6-.83 1.02-1.5 1.02h-2.78c-.65 0-1.24-.4-1.48-1l-8.35-20.5a1.6 1.6 0 0 1 1.48-2.2h1.73a1.59 1.59 0 0 1 1.49 1.02l5.18 13.24c.53 1.37 2.47 1.35 3-.02l4.95-13.2c.23-.62.83-1.04 1.5-1.04h1.35a1.6 1.6 0 0 1 1.47 2.18zm24.55 1.2c-.93-1.18-2.12-2.14-3.57-2.88-1.45-.73-3.23-1.1-5.33-1.1-1.77 0-3.4.32-4.9.95s-2.8 1.5-3.88 2.62c-1.08 1.12-1.93 2.43-2.55 3.95s-.92 3.16-.92 4.92c0 1.77.28 3.4.85 4.93s1.38 2.83 2.42 3.95c1.05 1.12 2.33 2 3.85 2.62s3.2.95 5.08.95c3.83 0 6.93-1.17 9.3-3.5.68-.67.58-1.8-.18-2.4l-.86-.66c-.64-.5-1.54-.4-2.12.16a10.74 10.74 0 0 1-1.9 1.52c-1.03.65-2.25.98-3.65.98-1.03 0-2.03-.17-3-.5s-1.82-.8-2.55-1.4a6.9 6.9 0 0 1-1.77-2.17 6.21 6.21 0 0 1-.31-.7c-.38-1.03.42-2.13 1.52-2.13H141c.88 0 1.6-.72 1.6-1.6 0-1.53-.2-3.04-.62-4.53-.43-1.46-1.1-2.8-2.04-3.98zm-3.96 6.53H125.5c-1.12 0-1.9-1.12-1.5-2.16a2.03 2.03 0 0 1 .11-.26c.35-.82.84-1.56 1.47-2.23s1.4-1.2 2.33-1.62c.92-.42 1.92-.62 3.02-.62 1.13 0 2.12.18 2.98.53.85.35 1.56.83 2.12 1.45.57.62 1 1.34 1.27 2.18.1.26.17.54.23.82.24.97-.54 1.9-1.56 1.9zm44.4-6.85c-1.13-1.13-2.47-2.02-4-2.68-1.53-.65-3.18-.97-4.95-.97s-3.42.32-4.95.97-2.87 1.54-4 2.68c-1.13 1.13-2.03 2.45-2.68 3.95s-.97 3.12-.97 4.85.33 3.36.97 4.88a12.17 12.17 0 0 0 2.68 3.95c1.13 1.12 2.47 2 4 2.65s3.18.98 4.95.98 3.42-.33 4.95-.98 2.87-1.53 4-2.65 2.03-2.43 2.67-3.95c.65-1.52.98-3.14.98-4.88 0-1.73-.33-3.35-.98-4.85a12.31 12.31 0 0 0-2.67-3.95zm-1.7 12.12c-.37 1.02-.88 1.88-1.55 2.6s-1.48 1.28-2.45 1.7-2.05.62-3.25.62-2.28-.2-3.25-.62c-.97-.42-1.78-.98-2.45-1.7s-1.18-1.58-1.55-2.6-.55-2.12-.55-3.33c0-1.2.18-2.3.55-3.32.37-1.02.88-1.88 1.55-2.6s1.48-1.28 2.45-1.7 2.05-.62 3.25-.62 2.28.2 3.25.62c.97.42 1.78.98 2.45 1.7s1.18 1.58 1.55 2.6.55 2.12.55 3.32c0 1.2-.18 2.32-.55 3.33zm61.3-11.8c-.93-1.18-2.12-2.14-3.58-2.88-1.45-.73-3.23-1.1-5.33-1.1-1.77 0-3.4.32-4.9.95s-2.8 1.5-3.88 2.62c-1.08 1.12-1.93 2.43-2.55 3.95s-.92 3.16-.92 4.92c0 1.77.28 3.4.85 4.93s1.38 2.83 2.43 3.95 2.33 2 3.85 2.62 3.2.95 5.08.95c3.83 0 6.93-1.17 9.3-3.5.68-.67.58-1.8-.18-2.4l-.86-.66c-.64-.5-1.54-.4-2.12.16a10.74 10.74 0 0 1-1.9 1.52c-1.03.65-2.25.98-3.65.98-1.03 0-2.03-.17-3-.5s-1.82-.8-2.55-1.4a7.07 7.07 0 0 1-1.78-2.17 6.21 6.21 0 0 1-.31-.7c-.38-1.03.42-2.13 1.52-2.13h15.52c.88 0 1.6-.72 1.6-1.6 0-1.53-.2-3.04-.62-4.53-.42-1.46-1.1-2.8-2.03-3.98zm-3.96 6.53h-10.46c-1.12 0-1.9-1.12-1.5-2.16a2.03 2.03 0 0 1 .11-.26c.35-.82.84-1.56 1.47-2.23s1.4-1.2 2.33-1.62c.92-.42 1.92-.62 3.03-.62 1.13 0 2.12.18 2.97.53s1.56.83 2.12 1.45c.57.62 1 1.34 1.28 2.18.1.26.17.54.23.82.23.97-.55 1.9-1.57 1.9zm80.65-27.67H25.63c-2.55 0-4.62 2.07-4.62 4.62v50c0 2.55 2.07 4.62 4.62 4.62h291.04c2.55 0 4.62-2.07 4.62-4.62v-50c0-2.55-2.07-4.62-4.62-4.62zm.62 54.62c0 .34-.28.62-.62.62h-122.5V58.6h.1c.8 1.23 1.95 2.2 3.45 2.92a11.09 11.09 0 0 0 4.8 1.08c1.83 0 3.5-.32 4.97-.95s2.75-1.5 3.8-2.62c1.05-1.12 1.86-2.43 2.42-3.95.57-1.52.85-3.16.85-4.93 0-1.73-.28-3.36-.85-4.88s-1.38-2.84-2.42-3.98c-1.05-1.13-2.32-2.02-3.8-2.65s-3.14-.95-4.97-.95c-1.6 0-3.16.35-4.67 1.05-1.52.7-2.7 1.68-3.58 2.95h-.1v-1.8c0-.88-.72-1.6-1.6-1.6h-1.3c-.88 0-1.6.72-1.6 1.6v35.87H25.63c-.34 0-.62-.28-.62-.62v-50c0-.34.28-.62.62-.62h122.7v35.87c0 .88.72 1.6 1.6 1.6h1.3c.88 0 1.6-.72 1.6-1.6V24.52h163.84c.34 0 .62.28.62.62v50zm-123.1-25c0-1.2.18-2.3.55-3.32.37-1.02.88-1.88 1.55-2.6s1.48-1.28 2.45-1.7 2.05-.62 3.25-.62 2.28.2 3.25.62c.97.42 1.78.98 2.45 1.7s1.18 1.58 1.55 2.6.55 2.12.55 3.32-.18 2.3-.55 3.33-.88 1.88-1.55 2.6-1.48 1.28-2.45 1.7-2.05.62-3.25.62-2.28-.2-3.25-.62c-.97-.42-1.78-.98-2.45-1.7s-1.18-1.58-1.55-2.6a9.94 9.94 0 0 1-.55-3.33zm106.07 18.7h-39.83c-2.55 0-4.62-2.07-4.62-4.62V36.06c0-2.55 2.07-4.62 4.62-4.62h39.83c2.55 0 4.62 2.07 4.62 4.62v28.16c0 2.55-2.07 4.62-4.62 4.62zm-39.83-33.4c-.34 0-.62.28-.62.62v28.16c0 .34.28.62.62.62h39.83c.34 0 .62-.28.62-.62V36.06c0-.34-.28-.62-.62-.62h-39.83zm36.45 9.82v-3.82c0-1.1-.9-2-2-2h-3.82c-1.1 0-2 .9-2 2v3.82c0 1.1.9 2 2 2h3.82c1.1 0 2-.9 2-2zM285 50.83c0-1.1-.9-2-2-2h-17.2c-1.1 0-2 .9-2 2s.9 2 2 2H283a2 2 0 0 0 2-2zm-4 8c0-1.1-.9-2-2-2h-13.2c-1.1 0-2 .9-2 2s.9 2 2 2H279a2 2 0 0 0 2-2z" />
      </svg>
      <img className="my-svg-alternate" width="96" height="96" src="envelope-logo.png" alt="Envelope logo" />

      <div className="inset">

        {(addressForm === 'sender') && <AddressForm
          subKey={addressForm}
          address={sender}
          clearAddress={clearSender}
          updateAddress={handleSenderChange}
          formDispatch={formDispatch}
          setAddressForm={setAddressForm}
        />
        }

        {(addressForm === 'recipient') && <AddressForm
          subKey={addressForm}
          address={recipient}
          clearAddress={clearRecipient}
          updateAddress={handleRecipientChange}
          formDispatch={formDispatch}
          setAddressForm={setAddressForm}
        />
        }

        <div className="center wrapper">

          <Form className="envelope-size center">
            <Form.Group>
              <Form.Field className="height-input">
                <Input id="height" control='input' labelPosition='right' value={size.height} onChange={handleSizeChange} >
                  <Label basic className="mini-label">height</Label>
                  <input />
                  <small className="help-height">3.5" – 6.25"</small>
                  <Label basic horizontal>"</Label>
                </Input>
              </Form.Field>
              <Form.Field className="width-input">
                <Input id="width" control='input' labelPosition='right' value={size.width} onChange={handleSizeChange} >
                  <Label basic className="mini-label">width</Label>
                  <input />
                  <small className="help-width">5" – 11.5"</small>
                  <Label basic horizontal>"</Label>
                </Input>
              </Form.Field>
              <div className="sizes">
                <Form.Field>
                  <Popup content='9.5" x 4.25"' size='mini' trigger={<Button onClick={() => setSize('#10')} basic>#10</Button>} />
                </Form.Field>
                <Form.Field>
                  <Popup content='8.87" x 3.87"' size='mini' trigger={<Button onClick={() => setSize('#9')} basic>#9</Button>} />
                </Form.Field>
                <Form.Field>
                  <Popup content='6.5" x 3.62"' size='mini' trigger={<Button onClick={() => setSize('#6 3/4')} basic>#6 3/4</Button>} />
                </Form.Field>
              </div>

            </Form.Group>

          </Form>

          {formData &&
            <Preview data={formData} openAddressEditor={setAddressForm} />
          }

        </div>
        <Button primary onClick={openPdf} className="download">Print Envelope</Button>
        {/* <Button primary onClick={downloadPdf} className="download" style={{ padding: '0 20px', margin: '0' }}>Download Envelope</Button> */}

        <div style={{paddingTop: '2em'}}>
          <a href="mailto:troy@realm7.com">feedback</a>
        </div>

      </div>

    </div>
  )
}

export default App
